import * as React from 'react';

import { SavePopupContainer } from '../../../../save/popup/container';
import { IconSearch } from '../../../../save/search_icon';
import * as tracking from './tracking';
import * as styles from './SaveSearchButton.css';

export interface ISaveSearchButtonProps {}

export interface ISaveSearchButtonState {
  isPopupOpen: boolean;
}

export class SaveSearchButton extends React.Component<ISaveSearchButtonProps, ISaveSearchButtonState> {
  public state: ISaveSearchButtonState = {
    isPopupOpen: false,
  };

  public render() {
    const { isPopupOpen } = this.state;

    return (
      <>
        <button className={styles['button']} onClick={this.handleButtonClick}>
          <IconSearch /> Сохранить поиск
        </button>
        {isPopupOpen && <SavePopupContainer onClose={this.handlePopupClose} isAdvancedFiltersOpened={true} />}
      </>
    );
  }

  private handleButtonClick = () => {
    this.setState({
      isPopupOpen: true,
    });

    tracking.trackButtonClick();
  };

  private handlePopupClose = () => {
    this.setState({
      isPopupOpen: false,
    });
  };
}
